import { APIClient } from "./axiosClient";
const api = new APIClient();

const path = "verified-info-logs";

const adultVerifyLogApi = {
  adultVerifyLogs(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },
};

export default adultVerifyLogApi;
